// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.changelog-markdown h1 {
    font-size: var(--chakra-fontSizes-xl);
    font-family: var(--chakra-fonts-heading);
    font-weight: var(--chakra-fontWeights-bold);
    line-height: 2;
  }
  
  .changelog-markdown h2 {
    font-size: var(--chakra-fontSizes-lg);
    font-family: var(--chakra-fonts-heading);
    font-weight: var(--chakra-fontWeights-bold);
    line-height: 2;
  }
  
  .changelog-markdown h3, h4, h5, h6 {
    font-size: var(--chakra-fontSizes-md);
    font-family: var(--chakra-fonts-heading);
    font-weight: var(--chakra-fontWeights-bold);
    line-height: 2;
  }
  
  .changelog-markdown ul {
    border-bottom-color: transparent;
    padding-left: 2rem;
  }
  
  .changelog-markdown input[type=checkbox] {
    margin-right: 4px;
  }
  
  .changelog-markdown code {
    font-weight: bold;
  }
  
  .changelog-markdown p {
    border-top-width: 0.3rem;
    border-top-color: transparent;
  }`, "",{"version":3,"sources":["webpack://./src/components/changelog-markdown.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,wCAAwC;IACxC,2CAA2C;IAC3C,cAAc;EAChB;;EAEA;IACE,qCAAqC;IACrC,wCAAwC;IACxC,2CAA2C;IAC3C,cAAc;EAChB;;EAEA;IACE,qCAAqC;IACrC,wCAAwC;IACxC,2CAA2C;IAC3C,cAAc;EAChB;;EAEA;IACE,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,6BAA6B;EAC/B","sourcesContent":[".changelog-markdown h1 {\n    font-size: var(--chakra-fontSizes-xl);\n    font-family: var(--chakra-fonts-heading);\n    font-weight: var(--chakra-fontWeights-bold);\n    line-height: 2;\n  }\n  \n  .changelog-markdown h2 {\n    font-size: var(--chakra-fontSizes-lg);\n    font-family: var(--chakra-fonts-heading);\n    font-weight: var(--chakra-fontWeights-bold);\n    line-height: 2;\n  }\n  \n  .changelog-markdown h3, h4, h5, h6 {\n    font-size: var(--chakra-fontSizes-md);\n    font-family: var(--chakra-fonts-heading);\n    font-weight: var(--chakra-fontWeights-bold);\n    line-height: 2;\n  }\n  \n  .changelog-markdown ul {\n    border-bottom-color: transparent;\n    padding-left: 2rem;\n  }\n  \n  .changelog-markdown input[type=checkbox] {\n    margin-right: 4px;\n  }\n  \n  .changelog-markdown code {\n    font-weight: bold;\n  }\n  \n  .changelog-markdown p {\n    border-top-width: 0.3rem;\n    border-top-color: transparent;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
